import {
  ContainerOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FormOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Modal, Button, Row, Col, notification } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import FormularioDeProdutosSimplificado from '../app/features/produtos/FormularioDeProdutosSimplificado';
import FormularioUsuario from '../app/features/FormularioUsuario';
import useProduto from '../core/hooks/useProduto';

import { Usuarios } from '../sdk';
import useCategoria from '../core/hooks/useCategoria';
import FormulariodeCategoriaSimplificado from '../app/features/FormulariodeCategoriaSimplificado';

const ModalCategoria = (props: {
  produtoId: string;
  restauranteId: string;
  quandoFinalizar: () => any;
}) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Form de cadastro de produtos');
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);
  const history = useHistory();
  //fazer a busca
  const { categoria, fetchCategoria } = useCategoria();

  useEffect(() => {
    fetchCategoria(props.produtoId);
  }, [fetchCategoria]);

  return (
    <>
      <div style={{ display: 'flex', gap: '5px', justifyContent: 'right' }}>
        <Button size='small' icon={<EditOutlined />} onClick={openCreationModal} />
        <Button
          size='small'
          icon={<ContainerOutlined />}
          onClick={() => {
            history.push(`/categoria/editar/${props.produtoId}`);
          }}
        />
      </div>
      <Modal
        title='Categoria'
        footer={null}
        visible={showCreationModal}
        onCancel={closeCreationModal}
        destroyOnClose
      >
        <FormulariodeCategoriaSimplificado
          onSuccess={() => {
            closeCreationModal();
            props.quandoFinalizar();
            notification.success({
              message: 'Categoria atualizada com sucesso',
            });
          }}
          produto={categoria}
          produtoId={props.produtoId}
          restauranteId={props.restauranteId}
        ></FormulariodeCategoriaSimplificado>
      </Modal>
    </>
  );
};

export default ModalCategoria;
